import type { ComponentProps } from 'react'
import { Input } from '@cocoonspace/ui/components/input'
import { cn } from '@cocoonspace/ui/lib/utils'
import { ClockIcon } from 'lucide-react'

export const TimePicker = ({
	className,
	...props
}: ComponentProps<typeof Input>) => {
	return (
		<div className={cn('relative grow', className)}>
			<Input
				className='peer appearance-none ps-9 [&::-webkit-calendar-picker-indicator]:hidden [&::-webkit-calendar-picker-indicator]:appearance-none'
				defaultValue='12:00'
				step='60'
				type='time'
				{...props}
			/>

			<div className='text-muted-foreground/80 pointer-events-none absolute inset-y-0 inset-s-0 flex items-center justify-center ps-3 peer-disabled:opacity-50'>
				<ClockIcon
					aria-hidden='true'
					size={16}
				/>
			</div>
		</div>
	)
}
